import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { GetFantomRunResponseType } from '@/entities';

export const getFantomRunPlays = async (): Promise<GetResponseType<GetFantomRunResponseType>> => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetFantomRunResponseType>(
    `${window.config.api_endpoint}/users/me/game/fantom-run`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};
